export function isAnsweredWithInput(
  currentQuestionViewIndex,
  childIndex,
  setQuizQuestions
) {
  const currentQuestion = this[currentQuestionViewIndex].children[childIndex];
  if (currentQuestion?.inputCondition?.call(this) === true) {
    return currentQuestion.inputValue?.length > 0;
  }
  return (
    currentQuestion.currSelected.length >=
    currentQuestion.selectionRange.minimumSelection
  );
}

export function minimumOptionsSelected(currentQuestionViewIndex, childIndex) {
  //if visibility condition is false for this question, then return true
  if (
    this[currentQuestionViewIndex].children[childIndex].visibilityCondition &&
    this[currentQuestionViewIndex].children[
      childIndex
    ].visibilityCondition?.call(this) === false
  ) {
    return true;
  }
  const currentQuestion = this[currentQuestionViewIndex].children[childIndex];
  return (
    currentQuestion.currSelected.length >=
    currentQuestion.selectionRange.minimumSelection
  );
}

export function isAnsweredWithBudget(currentQuestionViewIndex, childIndex) {
  //if visibility condition is false for this question, then return true
  if (
    this[currentQuestionViewIndex].children[childIndex].visibilityCondition &&
    this[currentQuestionViewIndex].children[
      childIndex
    ].visibilityCondition?.call(this) === false
  ) {
    return true;
  }
  const currentQuestion = this[currentQuestionViewIndex].children[childIndex];
  return (
    (currentQuestion.minBudget.length > 0 &&
      currentQuestion.maxBudget.length > 0) ||
    currentQuestion.monthlyBudget.length > 0
  );
}

export function isAnsweredWithUserInfo(currentQuestionViewIndex, childIndex) {
  const currentQuestion = this[currentQuestionViewIndex].children[childIndex];
  if (currentQuestion.hasPostalCode) {
    return (
      currentQuestion.postalCode &&
      currentQuestion.firstName &&
      currentQuestion.lastName &&
      currentQuestion.phoneNo &&
      currentQuestion.whereDidYouHereAboutUs
    );
  }
  return currentQuestion.phoneNo && currentQuestion.salesPersonInfo;
}
export function isAnsweredWithUserInfoPhoneAndEmail(
  currentQuestionViewIndex,
  childIndex
) {
  const currentQuestion = this[currentQuestionViewIndex].children[childIndex];
  const hasContact =
    (currentQuestion.email && currentQuestion.email.trim() !== "") ||
    (currentQuestion.phoneNo && currentQuestion.phoneNo.trim() !== "");
  if (currentQuestion.hasPostalCode) {
    return (
      currentQuestion.postalCode &&
      currentQuestion.firstName &&
      currentQuestion.lastName &&
      hasContact &&
      currentQuestion.whereDidYouHereAboutUs
    );
  }
  return (
    hasContact &&
    currentQuestion.salesPersonInfo &&
    currentQuestion.whereDidYouHereAboutUs
  );
}

export function isAnsweredWithMakeModel(currentQuestionViewIndex, childIndex) {
  return true; //is optional right now
  // const currentQuestion = this[currentQuestionViewIndex].children[childIndex];
  // return (
  //   currentQuestion.currSelected[0].make.length >= 0 &&
  //   currentQuestion.currSelected[0].model.length >= 0
  // );
}

export function isAnsweredWithTestDriveApproval(
  currentQuestionViewIndex,
  childIndex
) {
  const currentQuestion = this[currentQuestionViewIndex].children[childIndex];

  return (
    currentQuestion.applicantDetails.length > 0 &&
    currentQuestion.applicantDetails.every((applicant, _) => {
      return applicant.signature;
    }) &&
    (currentQuestion.testDriveApproval || currentQuestion.financePreApproval)
  );
}
